import { SxProps, Theme } from '@mui/material';

export const styles: Record<'upload' | 'continueButton' | 'icon', SxProps<Theme>> = {
  continueButton: {
    width: 'fit-content',
  },
  icon: {
    alignItems: 'center',
    backgroundColor: (theme) => theme.palette.gray[900],
    borderRadius: '50%',
    color: (theme) => theme.palette.tertiaryButton.main,
    display: 'flex',
    height: 32,
    justifyContent: 'center',
    width: 32,
  },
  upload: {
    alignItems: 'center',
    background: (theme) => theme.palette.gray[100],
    border: (theme) => `1px dashed ${theme.palette.gray[400]}`,
    borderRadius: '4px',
    display: 'flex',
    flexDirection: 'column',
    gap: (theme) => theme.spacing(1),
    justifyContent: 'center',
    padding: (theme) => theme.spacing(6, 15),
    textAlign: 'center',
  },
};
